export const DUAL_CURRENCY_DEPOSIT = 'newdcd';
export const RISK_REVERSAL = 'riskreversal';
export const STRANGLE = 'strangle';
export const STRADDLE = 'straddle';
export const VANILLA = 'vanilla';
export const VANILLA_STRIP = 'vanillastrip';
export const NDO = 'ndo';
export const ACCUMULATOR_MULTI_PERIOD = 'accumulatormultiperiod';
export const RISK_REVERSAL_STRIP = 'riskreversalstrip';
